module.exports = __webpack_public_path__ + "static/media/img_sp_introduction.2826ef45.jpg";